(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["LOGO-SLIDER"] && !Shopify.designMode) return;
  try {
    
(function() {
  // CRITICAL FIX: Ab hum ID ko HTML data attribute se read kar rahe hain.
  
  // Naya initialization function jo data attribute par depend karta hai
  function initializeCarouselByElement(sectionElement) {
      if (!sectionElement) {
          return;
      }
      
      // *** Ab yahan ID number resolve hoga ***
      const sectionId = sectionElement.dataset.sectionId;
      console.log(`COLLABS_DEBUG (V8): Data Attribute ID read: ${sectionId}`); 

      if (!sectionId) {
          console.error('COLLABS_DEBUG (V8): ERROR - Could not read data-section-id.');
          return;
      }

      console.log('COLLABS_DEBUG (V8): Initialization sequence started.');

      const wrapper = document.getElementById(`collabs-carousel-${sectionId}`);
      const leftArrow = sectionElement.querySelector('.arrow-left');
      const rightArrow = sectionElement.querySelector('.arrow-right');
      const firstBlock = wrapper.querySelector('.collab-block');

      if (!leftArrow || !rightArrow || !firstBlock) {
          if (leftArrow) leftArrow.style.display = 'none';
          if (rightArrow) rightArrow.style.display = 'none';
          return;
      }

      let gap = 0;
      function updateGap() {
        const gapString = window.getComputedStyle(wrapper).gap;
        gap = parseInt(gapString, 10) || 0;
      }
      updateGap(); 

      function updateArrowVisibility() {
        const scrollPos = wrapper.scrollLeft;
        const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
        const tolerance = 5; 
        
        const isAtStart = scrollPos < tolerance;
        const isScrollable = maxScroll > tolerance; 
        
        if (!isScrollable) {
            leftArrow.classList.add('hidden-on-load');
            rightArrow.classList.add('hidden-at-end');
            return;
        }

        const isAtEnd = scrollPos >= (maxScroll - tolerance);
        
        leftArrow.classList.toggle('hidden-on-load', isAtStart);
        rightArrow.classList.toggle('hidden-at-end', isAtEnd);
      }

      function scrollCarousel(direction) {
        const blockWidth = firstBlock.offsetWidth;
        let scrollAmount = 0;
        
        if (blockWidth > 0) {
          scrollAmount = (blockWidth + gap) * direction;
        } else {
          scrollAmount = (wrapper.clientWidth / 2) * direction; 
        }
        
        console.log(`COLLABS_DEBUG (V8): Click Event Fired. Scrolling by: ${scrollAmount}px`);

        if (Math.abs(scrollAmount) > 0) {
          wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      }

      // --- Event Listeners ---
      leftArrow.addEventListener('click', (e) => {
          e.preventDefault(); 
          scrollCarousel(-1)
      });
      rightArrow.addEventListener('click', (e) => {
          e.preventDefault(); 
          scrollCarousel(1)
      });
      wrapper.addEventListener('scroll', updateArrowVisibility);

      // Resize observer
      new ResizeObserver(() => {
        updateGap();
        updateArrowVisibility();
      }).observe(sectionElement);

      // Initial Check
      updateArrowVisibility();
  }

  // --- Main Initialization Logic ---
  function initializeAllCarousels() {
    console.log('COLLABS_DEBUG (V8): Script file loaded. Scanning for sections...');
    // Hum document mein saare carousel elements ko ढूंढ rahe hain
    const carouselSections = document.querySelectorAll('.collabs-carousel-section[data-section-id]');
    
    carouselSections.forEach(initializeCarouselByElement);
  }

  window.addEventListener('load', initializeAllCarousels);

  // Shopify Editor ke liye:
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      // Jab section load hota hai, hum us naye element ko initialize karte hain
      const newSectionElement = document.getElementById(`collabs-section-${event.detail.sectionId}`);
      if (newSectionElement) {
        initializeCarouselByElement(newSectionElement);
      }
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
